import { getApiLocation, getApiWeather } from '../../weather_widget/api'
import { getCurrentPosition, validateLocation, validateWeather } from '../../weather_widget/utils'

export const getCurrentWeather = async () => {
  const geolocation = getCurrentPosition()

  try {
    const location = await getApiLocation(geolocation)
    const weather = await getApiWeather(location.source.locationId)

    if (validateLocation(location) && validateWeather(weather)) {
      return {
        weatherData: weather,
        locationData: location.location,
        loading: false,
        source: location.source
      }
    }
    console.error(`Invalid location or weather response from API`, location, weather)
    return {}
  } catch (e) {
    console.error(`Error occurred from Location API`, e)
    return {}
  }
}
